import { Item } from "../../../services/types";
import { Address } from "../addresses/types";
import { Company } from "../companies/types";
import { LegalRepresentative } from "../legalRepresentatives/types";
import { LegalSeat } from "../legalSeats/types";

export const isMember = (member?: Member): boolean => member?.type == ordinary && member?.status == definitive;

const canceled = "canceled";
const definitive = "definitive";
export const renderStatus = (status?: string | null): string => {
  switch (status) {
    case canceled: {
      return "Annulliert";
    }
    case definitive: {
      return "Definitiv";
    }
    default: {
      return status ?? "";
    }
  }
};

const ordinary = "ordinary";
const extraordinary = "extraordinary";
const client = "client";
const freeNewspaper = "free-newspaper";
const newspaperSubscription = "newspaper-subscription";
const domesticWorkers = "domestic-worker";
export const renderType = (type?: string | null): string => {
  switch (type) {
    case ordinary: {
      return "Ordentlich";
    }
    case extraordinary: {
      return "Außerordentlich";
    }
    case client: {
      return "Kunde";
    }
    case freeNewspaper: {
      return "Gratis-Zeitung";
    }
    case newspaperSubscription: {
      return "Zeitung-Abo";
    }
    case domesticWorkers: {
      return "Hausangestellte";
    }
    default: {
      return type ?? "";
    }
  }
};

const company = "company";
const corporation = "corporation";
const partnership = "partnership";
const others = "others";
const soleProprietorship = "soleProprietorship";
const privatePerson = "privatePerson";
export const renderCompanyType = (type?: string | null): string => {
  switch (type) {
    case company: {
      return "Gesellschaft";
    }
    case corporation: {
      return "Kapitalgesellschaft";
    }
    case partnership: {
      return "Personengesellschaft";
    }
    case others: {
      return "Andere";
    }
    case soleProprietorship: {
      return "Einzelunternehmen";
    }
    case privatePerson: {
      return "Privatperson";
    }
    default: {
      return type ?? "";
    }
  }
};

const ownershipLeaseHolder = "leaseholder";
const ownershipOwner = "owner";
const ownershipLandlord = "landlord";
const ownershipPrivate = "private";
const ownershipOther = "other";
export const renderOwnership = (ownership?: string | null): string => {
  switch (ownership) {
    case ownershipLeaseHolder: {
      return "Pächter";
    }
    case ownershipOwner: {
      return "Eigentümer";
    }
    case ownershipLandlord: {
      return "Verpächter";
    }
    case ownershipPrivate: {
      return "Privat";
    }
    case ownershipOther: {
      return "Sonstiges";
    }
    default: {
      return ownership ?? "";
    }
  }
};

export interface Member extends Item {
  id: number;
  entryDate: string | null;
  exitDate: string | null;
  exitReason: string | null;
  createdAt?: string;
  updatedAt?: string;
  name: string;
  taxCode: string | null;
  vat: string | null;
  uidNr: string | null;
  email: string | null;
  pec: string | null;
  phone: string | null;
  type: string | null;
  status: string | null;
  companyType: string | null;
  legalForm: string | null;
  gender: "male" | "female" | "entity" | null;
  website: string | null;
  notes: string | null;
  address: Address;
  isMember: boolean;
  companies: Company[];
  legalSeats: LegalSeat[];
  legalRepresentative: LegalRepresentative | null;
}
